// extracted by mini-css-extract-plugin
export default {"container":"welcome_container__1PhG3","modal":"welcome_modal__TydUr","banner":"welcome_banner__gdNvK"};